<div class="container" *ngIf="!showLoading">
  <environment-status [status]="status"></environment-status>
  <div class="maintenance-window">
    <div class="maintenance-window__header">
      <div class="maintenance-window__header-info">
        <div class="maintenance-window__header-title">{{'MAINTENANCE.TITLE_CLEAN' | translate}}</div>
        <div class="maintenance-window__header-text">{{'MAINTENANCE.TEXT_START_MAINTENANCE' | translate}}</div>
      </div>
      <div >
        <button type="button" *ngIf="status === 2" class="maintenance-window__header-btn-stop bz-space--stack-m bz-btn bz-btn--m" (click)="changeStatus()">
          <bzg-icon class="bz-space--inline-s" [nameIcon]="'icon-stop'" [size]="16">
          </bzg-icon>
          <span *ngIf="status === 2">{{'MAINTENANCE.STOP_MAINTENANCE' | translate}}
          </span>
        </button>
        <button type="button" *ngIf="status === 0" class="bz-space--stack-m bz-btn bz-btn--m" (click)="changeStatus()">
          <bzg-icon class="bz-space--inline-s" [nameIcon]="'icon-run'" [size]="16">
          </bzg-icon>
          <span *ngIf="status === 0">{{'MAINTENANCE.START_MAINTENANCE_WINDOW' | translate}}
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="mc-maintenance">
    
    <biz-accordion [title]="'MAINTENANCE.USERS_MAINTENANCE_WINDOW'" [subtitle]="'MAINTENANCE.SUBTITLE_USERS_MAINTENANCE_WINDOW'" [isCollapsed]="accordionCollapsedState[0]" (isOpen)="accordionHandler($event, 0)">
      
      <form #customizeMessageForm="ngForm" class="mc-maintenance__container">
        <bzg-input class="mc-maintenance__message" [(ngModel)]="customizedMessage.title" name="customize-title" required="true" [maxlength]="116">
          {{'MAINTENANCE.TITLE' | translate}}
          <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
        </bzg-input>
        <bzg-textarea [(ngModel)]="customizedMessage.description" class="mc-maintenance__message" [required]="true" name="customize-description" [maxlength]="1221">
          {{'MAINTENANCE.MESSAGE' | translate}}
          <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
        </bzg-textarea>
        
        <div class="mc-maintenance__buttons">
          <bzg-button-secondary class="mc-maintenance__buttons-clear" (click)="clearCustomizeMessage()">
            {{'GLOBAL.CLEAR' | translate}}
          </bzg-button-secondary>
          <bzg-button-primary class="mc-maintenance__buttons-save" (click)="updateCustomizeMessage()" [disabled]="!isFormValid(customizeMessageForm)">
            {{'MAINTENANCE.SAVE' | translate}}
          </bzg-button-primary>
        </div>
      </form>

    </biz-accordion>
    

    <biz-accordion [title]="'MAINTENANCE.USERS_WORKPORTAL'" [subtitle]="'MAINTENANCE.SUBTITLE_USERS_WORKPORTAL'" [isCollapsed]="accordionCollapsedState[1]" (isOpen)="accordionHandler($event, 1)">
      
      <form #upcomingMessageForm="ngForm" class="mc-maintenance__container">
        <div class="form-group">
          <div class="mc-maintenance-col-2 form-group">
            <div class="mc-maintenance-col-date-picker">
              <div class="mc-maintenance-date__field--left bz-form-item--required bz-form-item" [ngClass]="{'bz-form-item--error' :
              (dpFromControl.invalid || areDatesInvalid()) && (dpFromControl.dirty || dpFromControl.touched)}">
                <label class="bz-form-label">{{'GLOBAL.FROM' | translate}}
                  <span class="bz-required__icon">*</span>
                </label>
                <div class="bz-input-icon">
                  <input class="bz-input bz-input-icon__input bz-space--inline-s"
                         autocomplete="off"
                         mask="00/00/0000"
                         id="date-from"
                         #dpFrom="bsDatepicker"
                         #dpFromControl="ngModel"
                         (focusin)="dpTo.hide()"
                         [(ngModel)]="upcomingMessage.startedDate"
                         (click)="setDatePickerActive('dpFrom')"
                         (ngModelChange)="areDatesInvalid()"
                         name="date-from"
                         [bsConfig]="{ maxDate: upcomingMessage.finishedDate, showWeekNumbers: false  }"
                         required
                         bsDatepicker>
                  <svg class="bz-icn bz-space--inline-s" height="26px" width="26px" (click)="dpFrom.show()">
                    <use xlink:href="#icon-calendar"></use>
                  </svg>
                </div>
                 <div class="bz-form-message">
                   <span class="bz-form-message__error" *ngIf="dpFromControl.invalid && (dpFromControl.dirty || dpFromControl.touched) && dpFromControl.errors.required">
                     <svg class="bz-icn bz-space--inline-s" width="16px" height="16px">
                       <use xlink:href="#icn-input-error" />
                     </svg>
                     <label class="bz-form-message__text">
                       {{'GLOBAL.REQUIRED_FIELD' | translate}}
                     </label>
                   </span>
                 </div>
              </div>
            </div>
  
            <div class="mc-maintenance-col-time">
              <bzg-time-picker name="started-date" [(ngModel)]="startedDateTime" [required]="true" [ngClass]="{'bz-form-item--error' : areDatesInvalid()}">
                {{'MAINTENANCE.TIME' | translate}}
              </bzg-time-picker>
            </div>
          </div>
          

          <div class="mc-maintenance-col-2 form-group">
            <div class="mc-maintenance-col-date-picker">
              <div class="mc-maintenance-date__field--left bz-form-item--required bz-form-item" [ngClass]="{'bz-form-item--error' :
              (dpToControl.invalid || areDatesInvalid()) && (dpToControl.dirty || dpToControl.touched)}">
                <label class="bz-form-label">{{'GLOBAL.TO' | translate}}
                  <span class="bz-required__icon">*</span>
                </label>
                <div class="bz-input-icon">
                  <input class="bz-input bz-input-icon__input bz-space--inline-s"
                         autocomplete="off"
                         mask="00/00/0000"
                         id="date-to"
                         #dpTo="bsDatepicker"
                         #dpToControl="ngModel"
                         (focusin)="dpFrom.hide()"
                         [(ngModel)]="upcomingMessage.finishedDate"
                         (click)="setDatePickerActive('dpTo')"
                         (ngModelChange)="areDatesInvalid()"
                         name="date-to"
                         [bsConfig]="{ minDate: upcomingMessage.startedDate, showWeekNumbers: false }"
                         required
                         bsDatepicker>
                  <svg class="bz-icn bz-space--inline-s" height="26px" width="26px" (click)="dpTo.show()">
                    <use xlink:href="#icon-calendar"></use>
                  </svg>
                </div>
                 <div class="bz-form-message">
                   <span class="bz-form-message__error" *ngIf="dpToControl.invalid && (dpToControl.dirty || dpToControl.touched) && dpToControl.errors.required">
                     <svg class="bz-icn bz-space--inline-s" width="16px" height="16px">
                       <use xlink:href="#icn-input-error" />
                     </svg>
                     <label class="bz-form-message__text">
                       {{'GLOBAL.REQUIRED_FIELD' | translate}}
                     </label>
                   </span>
                 </div>
              </div>
            </div>
  
            <div class="mc-maintenance-col-time">
              <bzg-time-picker name="finished-date" [(ngModel)]="finishedDateTime" [required]="true" [ngClass]="{'bz-form-item--error' : areDatesInvalid()}">
                {{'MAINTENANCE.TIME' | translate}}
              </bzg-time-picker>
            </div>
          </div>
          
        </div>
        <bzg-textarea [(ngModel)]="upcomingMessage.message" class="mc-maintenance-display__message" [required]="true" name="message" [maxlength]="1221">
          {{'MAINTENANCE.MESSAGE' | translate}}
          <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
        </bzg-textarea>
        <div class="mc-maintenance__buttons">
          <bzg-button-secondary class="mc-maintenance__buttons-clear" (click)="clearUpcomingMessage()">{{'GLOBAL.CLEAR' | translate}}</bzg-button-secondary>
          <bzg-button-primary class="mc-maintenance__buttons-save" (click)="updateShowUpcomingMessage()"
                              [disabled]="!isFormValid(upcomingMessageForm)">{{'MAINTENANCE.SAVE' | translate}}</bzg-button-primary>
        </div>
      </form>
    </biz-accordion>
  </div>
</div>

<loading-maintenance [messageType]="messageType" *ngIf="showLoading"></loading-maintenance>
